import { useQuery } from '@tanstack/react-query'

import { getQueryClient,QueryKey } from 'shared/api'

import { getInvoiceAddressesQuery } from '../api'
import { CustomerInvoiceAddress } from '../types'

export const useQueryCustomerInvoiceAddresses = (token: string) => {
  return useQuery({
    queryKey: [QueryKey.invoiceAddresses, token],
    queryFn: () => getInvoiceAddressesQuery(token || ''),
    enabled: !!token,
    staleTime: 60000
  })
}

export const queryFetchInvoiceAddresses = async (token: string) => {
  return await getQueryClient().fetchQuery<CustomerInvoiceAddress[]>({
    queryKey: [QueryKey.invoiceAddresses, token],
    queryFn: () => getInvoiceAddressesQuery(token || '')
  })
}
